import PeopleCircles from "@/components/PeopleCircles"
import type { Person } from "@/lib/person"

// Reviewer picks + the skip toggle for one settings row. Skip ON hides the
// picker entirely — "don't make me think": an empty picker under an ON
// toggle reads as something left unfinished.
export default function ReviewerFields({ skipReview, reviewerIds, people, readOnly, disabled, onChange }: {
  skipReview: boolean
  reviewerIds: string[]
  people: Person[]
  // readOnly: the viewer may not change settings at all. disabled: the form
  // is busy (saving) — fields stay visible but inert.
  readOnly: boolean
  disabled: boolean
  onChange: (patch: { skip_review?: boolean; reviewer_user_ids?: string[] }) => void
}) {
  return (
    <>
      <label className="flex items-center gap-2 text-sm text-foreground">
        <span className="w-40 shrink-0">Review</span>
        <input
          type="checkbox"
          className="size-4 accent-primary"
          checked={!skipReview}
          disabled={disabled}
          onChange={(e) => onChange({ skip_review: !e.target.checked })}
        />
        <span className="text-xs text-muted-foreground">
          {skipReview ? "Off — submitted work completes immediately" : "On — a reviewer must approve submitted work"}
        </span>
      </label>
      {!skipReview && (
        <div className="flex items-start gap-2">
          <span className="w-40 shrink-0 pt-1.5 text-sm text-foreground">Reviewer</span>
          <PeopleCircles
            title="Reviewer"
            people={people}
            selectedIds={reviewerIds}
            onChange={(ids) => onChange({ reviewer_user_ids: ids })}
            editable={!readOnly}
            disabled={disabled}
          />
        </div>
      )}
    </>
  )
}
